import React, { useEffect, useState } from 'react';
import api from '../../utils/api';
import { Plus, Trash2 } from 'lucide-react';
import { toast } from 'sonner';

const Units = () => {
  const [units, setUnits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({ name: '', symbol: '', description: '' });

  useEffect(() => { fetchData(); }, []);
  const fetchData = async () => {
    setLoading(true);
    try { const r = await api.get('/sales/units'); setUnits(r.data); }
    catch (e) { console.error(e); } finally { setLoading(false); }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try { await api.post('/sales/units', formData); setShowModal(false); setFormData({ name: '', symbol: '', description: '' }); fetchData(); }
    catch (err) { toast.error(err.response?.data?.detail || 'Failed'); }
  };

  const handleDelete = async (id, name) => {
    if (!window.confirm(`Delete unit "${name}"?`)) return;
    try { await api.delete(`/sales/units/${id}`); fetchData(); }
    catch (err) { toast.error(err.response?.data?.detail || 'Failed'); }
  };

  return (
    <div data-testid="units-page">
      <div className="flex items-center justify-between mb-4">
        <h1 style={{ fontSize: '24px', fontWeight: 700, margin: 0 }}>Unit Master</h1>
        <button onClick={() => { setFormData({ name: '', symbol: '', description: '' }); setShowModal(true); }} className="btn btn-primary" data-testid="add-unit-btn"><Plus size={16} /> Add Unit</button>
      </div>

      <div className="card">
        {loading ? <div>Loading...</div> : (
          <div className="table-container">
            <table>
              <thead><tr><th>Name</th><th>Symbol</th><th>Description</th><th>Actions</th></tr></thead>
              <tbody>
                {units.length === 0 ? <tr><td colSpan={4} style={{ textAlign: 'center', padding: '20px', color: 'var(--text-tertiary)' }}>No units</td></tr> : units.map(u => (
                  <tr key={u.id} data-testid={`unit-row-${u.symbol}`}>
                    <td style={{ fontWeight: 500 }}>{u.name}</td>
                    <td><span className="badge badge-info">{u.symbol}</span></td>
                    <td className="text-sm">{u.description || '-'}</td>
                    <td><button onClick={() => handleDelete(u.id, u.name)} className="btn btn-ghost btn-sm"><Trash2 size={14} color="#dc2626" /></button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {showModal && (
        <div className="modal-overlay" data-testid="unit-modal">
          <div className="modal-content" style={{ maxWidth: '400px' }} onClick={(e) => e.stopPropagation()}>
            <div className="modal-header"><h2 style={{ margin: 0, fontSize: '18px', fontWeight: 700 }}>Add Unit</h2></div>
            <form onSubmit={handleSubmit}>
              <div className="modal-body">
                <div className="form-group"><label className="form-label">Unit Name *</label><input type="text" className="form-input" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} required placeholder="e.g. Kilogram" data-testid="unit-name" /></div>
                <div className="form-group"><label className="form-label">Symbol *</label><input type="text" className="form-input" value={formData.symbol} onChange={(e) => setFormData({ ...formData, symbol: e.target.value })} required placeholder="e.g. kg" data-testid="unit-symbol" /></div>
                <div className="form-group"><label className="form-label">Description</label><input type="text" className="form-input" value={formData.description} onChange={(e) => setFormData({ ...formData, description: e.target.value })} data-testid="unit-desc" /></div>
              </div>
              <div className="modal-footer">
                <button type="button" onClick={() => setShowModal(false)} className="btn btn-secondary">Cancel</button>
                <button type="submit" className="btn btn-primary" data-testid="submit-unit-btn">Add Unit</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Units;
